import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { HeaderIcons } from 'swag-client-common/components/partials/header-icons/header-icons';
import { getSuperSpeedFromLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import { forbiddenForBoxSelector, isForbiddenForInventorySelector, isLimitedEditionSelector, isForbiddenToShipInternationallySelector } from '../../../../../../../../redux/product/product.selectors';
const mapStateToProps = createStructuredSelector({
  isForbiddenForInventory: isForbiddenForInventorySelector,
  isLimitedEdition: isLimitedEditionSelector,
  acceptableForBox: createSelector(forbiddenForBoxSelector, forbiddenForBox => !forbiddenForBox),
  showSuperSpeedIcon: getSuperSpeedFromLS,
  isForbiddenToShipInternationally: isForbiddenToShipInternationallySelector
});
export default connect(mapStateToProps)(HeaderIcons);